module.exports = __webpack_public_path__ + "img/free.ca2823c5.png";